// Log-out button.
import { useState } from 'react';
import { useAuth } from './AuthContext';

export default function LogOut({ onDone }) {
  const { signOut } = useAuth();
  const [busy, setBusy] = useState(false);

  async function handleClick() {
    if (busy) return;
    setBusy(true);
    await signOut();
    setBusy(false);
    onDone?.();
  }

  return (
    <button
      className="btn btn-ghost"
      onClick={handleClick}
      disabled={busy}
      style={{ borderColor: 'rgba(248,113,113,0.5)', color: 'var(--red)', width: '100%' }}
    >
      {busy ? 'Logging out…' : 'Log out'}
    </button>
  );
}
